/*
 * @Author: Json Chen
 * @Date: 2021-07-20 16:59:20
 * @LastEditTime: 2022-06-02 17:54:54
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Localisation/Components/CommonFormItem.tsx
 */

import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
// import { useRequest } from 'ahooks';
import { Form, Spin } from 'antd';
import React, { useMemo } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  dateFormatOptions,
  decimalSeparatorOptions,
  thousandsSeparatorOptions,
  timeFormatOptions,
} from '../config';
import styles from '../style.module.less';
import { SalesChannelMode } from 'src/types/common/SalesChannel';
import { useSalesChannelMode } from 'src/constrains/SalesChannelHOC/useSalesChannel';

const CommonFormItem = ({
  timezoneOptions = [],
  disableEdit,
  disabled,
  isStore,
}: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const mode = useSalesChannelMode();

  const timezones = useMemo(() => {
    return (timezoneOptions || []).map((t) => ({
      label: `${t.timezone}(${t.timezoneInGmt})`,
      value: t.timezone,
    }));
  }, [timezoneOptions]);

  return disabled ? null : (
    <div className={styles.commonFormItem}>
      <Spin spinning={false}>
        <div className={styles.formItemLayout}>
          <div className={styles.twoInOneRow}>
            <Form.Item
              name={'timezone'}
              label={
                <div className={styles.formItemLabel}>
                  {getI18n('general.timeZone')}
                </div>
              }
              className={styles.twoInOneRowItem}>
              <SelectObjectAsValue
                options={timezones}
                size={'large'}
                disabled={disableEdit}
              />
            </Form.Item>
          </div>
          <div className={styles.twoInOneRow}>
            <Form.Item
              className={styles.twoInOneRowItem}
              name={'dateFormat'}
              initialValue={dateFormatOptions[0].value}
              label={
                <div className={styles.formItemLabel}>
                  {getI18n('general.dateFormat')}
                </div>
              }>
              <SelectObjectAsValue
                options={dateFormatOptions}
                size={'large'}
                disabled={disableEdit}
              />
            </Form.Item>
            <Form.Item
              className={styles.twoInOneRowItem}
              name={'timeFormat'}
              initialValue={timeFormatOptions[0].value}
              label={
                <div className={styles.formItemLabel}>
                  {getI18n('general.timeFormat')}
                </div>
              }>
              <SelectObjectAsValue
                options={timeFormatOptions}
                size={'large'}
                disabled={disableEdit}
              />
            </Form.Item>
          </div>
          {isStore || mode === SalesChannelMode.ECOMMERCE ? (
            <div className={styles.twoInOneRow}>
              <Form.Item
                className={styles.twoInOneRowItem}
                name={'decimalSeparator'}
                initialValue={decimalSeparatorOptions[0].value}
                label={
                  <div className={styles.formItemLabel}>
                    {getI18n('general.decimalSeparator')}
                  </div>
                }>
                <SelectObjectAsValue
                  options={decimalSeparatorOptions.map((item) => ({
                    label: getI18n(item.labelKey),
                    value: item.value,
                  }))}
                  size={'large'}
                  disabled={disableEdit}
                />
              </Form.Item>
              <Form.Item
                className={styles.twoInOneRowItem}
                name={'thousandsSeparator'}
                initialValue={thousandsSeparatorOptions[0].value}
                label={
                  <div className={styles.formItemLabel}>
                    {getI18n('general.thousandsSeparator')}
                  </div>
                }>
                <SelectObjectAsValue
                  options={thousandsSeparatorOptions.map((item) => ({
                    label: getI18n(item.labelKey),
                    value: item.value,
                  }))}
                  size={'large'}
                  disabled={disableEdit}
                />
              </Form.Item>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Spin>
    </div>
  );
};

export default CommonFormItem;
